var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtesis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "155.2px",
    height: "153.4px",
    viewBox: "0 0 155.2 153.4",
    style: {
      enableBackground: "new 0 0 155.2 153.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#4D4D4D;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#666666;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#CCCCCC;}\r\n\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.2,132c-11.2,10.8-24.6,16.3-40.3,16.6c0-8,0-15.7,0-23.6c9.1-0.2,17-3.5,23.5-9.7 C72,120.9,77.5,126.4,83.2,132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.1,88.1c5.6-5.6,11.1-11.2,16.8-16.8c10.8,11.1,16.3,24.5,16.6,40.2c-0.7,0.1-1.2,0.2-1.6,0.2 c-6.8,0-13.7,0-20.5,0c-1.1,0-1.7-0.2-1.7-1.5C125.3,101.5,121.9,94.2,116.1,88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104,151.9c-5.5-5.5-11-11-16.6-16.6c0.5-0.6,1-1.2,1.6-1.9c4.7-5.6,7.4-12,7.8-19.4c0.1-1.7,0.6-2.3,2.4-2.3 c6.4,0.1,12.7,0,19.1,0c0.6,0,1.3,0.1,1.9,0.1C122.7,121.3,113.9,142.9,104,151.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.4,1.7c5.6,5.6,11,11,16.6,16.5c-6.2,6.5-9.5,14.3-9.8,23.6c-1.3,0-2.5,0-3.6,0c-6,0-12,0-18,0 c-1.3,0-1.9-0.3-1.8-1.7C35.4,25.5,40.7,13,50.6,2.3C50.9,2.1,51.1,1.9,51.4,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39,65.6c-5.6,5.6-11,11-16.7,16.7c-1.6-1.9-3.4-3.9-5-6c-7-9.4-10.8-20-11.3-31.8C6,42.7,6.4,42,8.3,42.1 c6.3,0.1,12.6,0.1,18.9,0c1.6,0,2.1,0.5,2.2,2C30.1,52.4,33.2,59.6,39,65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.8,50.5c-5.7,5.7-11.2,11.2-16.5,16.5c-2.7-1.8-5.3-3.8-8.2-5.5c-4.3-2.5-9-3.6-14-3.9 c-0.9-0.1-1.7-0.1-1.7-1.3c0-7.2,0-14.3,0-21.5c0-0.2,0.1-0.5,0.2-0.8C128.3,34.2,141.7,39.7,152.8,50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,87.1c2.7,1.8,5.5,3.8,8.6,5.5c4,2.2,8.3,3.4,12.9,3.5c1.5,0,2,0.6,2,2.1c-0.1,6.5-0.1,13,0,19.5 c0,1.5-0.5,1.9-1.9,1.9c-12.6-0.7-23.9-4.8-33.7-12.7c-1.5-1.2-2.8-2.5-4.1-3.5C8.3,97.8,13.7,92.4,19.1,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.9,37.9c-5.6-5.5-11-10.8-16.6-16.3c3.6-3.8,7.8-6.8,12.4-9.4C92.6,8,101,5.6,110,5.3 c1.6-0.1,2.2,0.4,2.2,2c-0.1,6.4,0,12.9,0,19.3c0,0.9,0.1,1.8-1.3,1.9c-8.3,0.5-15.5,3.6-21.6,9.2C89.1,37.9,88.9,37.9,88.9,37.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtesis);
export default __webpack_public_path__ + "static/media/artesis.17fa7c9075d8c36b4b121bf55df63009.svg";
export { ForwardRef as ReactComponent };